import React from 'react';
import { SecureHtml } from '@wix/wix-emails-secure-components';
import { useRemainingWidth } from '../width-context';
import { CommentStart, CommentEnd } from '../comments';
import { ColumnItem } from '../column-item';
import { useConfig } from '../config-context';
export function Divider(props) {
    var _a = props.borderColor, borderColor = _a === void 0 ? '#000000' : _a, _b = props.borderWidth, borderWidth = _b === void 0 ? '4px' : _b, cssClass = props.cssClass, _c = props.padding, padding = _c === void 0 ? '10px 25px' : _c, paddingBottom = props.paddingBottom, paddingLeft = props.paddingLeft, paddingRight = props.paddingRight, paddingTop = props.paddingTop, _d = props.width, width = _d === void 0 ? '100%' : _d;
    var remainingWidth = useRemainingWidth({
        width: width,
        padding: padding,
        paddingLeft: paddingLeft,
        paddingRight: paddingRight,
    }).width;
    var renderComments = useConfig().renderComments;
    return (React.createElement(ColumnItem, { align: "center", padding: padding, cssClass: cssClass, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, paddingTop: paddingTop },
        React.createElement("p", { style: {
                borderTop: "solid " + borderWidth + " " + borderColor,
                fontSize: '1px',
                margin: '0px auto',
                width: width,
            } }),
        renderComments && (React.createElement(React.Fragment, null,
            React.createElement(CommentStart, null),
            React.createElement("table", { align: "center", border: "0", cellPadding: "0", cellSpacing: "0", style: {
                    borderTop: "solid " + borderWidth + " " + borderColor,
                    fontSize: '1px',
                    margin: '0px auto',
                    width: remainingWidth + "px",
                }, role: "presentation", width: remainingWidth + "px" },
                React.createElement("tr", null,
                    React.createElement(SecureHtml, { containerProps: { style: { height: '0', lineHeight: '0' } }, html: '&nbsp;', as: "td", skipCleaning: true }))),
            React.createElement(CommentEnd, null)))));
}
//# sourceMappingURL=divider.js.map